var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 48,
    viewBox: "0 0 27 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13041 26.9999V48H17.5217V26.9999H24.5241L25.8564 18.313H17.5217V12.6757C17.5217 10.2991 18.6859 7.98259 22.4191 7.98259H26.2086V0.586955C26.2086 0.586955 22.7695 0 19.4815 0C12.617 0 8.13041 4.16034 8.13041 11.6921V18.313H0.5V26.9999H8.13041Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.3e3ea3b41acc938103ef940d35751c77.svg";
export { ForwardRef as ReactComponent };